export default [
  {
    path: '/itf/classificators',
    name: 'itf-classificators',
    component: () => import('@/views/pages/itf/Classificators'),
    meta: {
      auth: true,
      pageTitle: 'Արատորոշումներ',
    },
  },
  {
    path: '/itf/engine-types',
    name: 'itf-engine-types',
    component: () => import('@/views/pages/itf/EngineTypes'),
    meta: {
      auth: true,
      pageTitle: 'Շարժիչների տեսակներ',
    },
  },
  {
    path: '/itf-all',
    name: 'itf-all',
    component: () => import('@/views/pages/itf/All'),
    meta: {
      auth: true,
      pageTitle: 'ITF',
    },
  },
  {
    path: '/itf-view',
    name: 'itf-view',
    component: () => import('@/views/pages/itf/View'),
    meta: {
      auth: true,
      pageTitle: 'ITF',
    },
  },
  {
    path: '/itf-company',
    name: 'itf-company',
    component: () => import('@/views/pages/itf/Company'),
    meta: {
      auth: true,
      pageTitle: 'ITF',
    },
  },
]
